import * as React from 'react';
import {
  Typography,
  Link,
  Modal,
  Box,
  IconButton,
  Divider,
  DialogActions,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';


const classes = {
    closeButton: {position: 'absolute', top: '16px', right: '16px'},
    divider: {y: 3},
    modalStyle: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '800px',
        maxHeight: '80vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        px: {xs: 1, sm: 4},
        py: 1,
        borderRadius: 2,
        overflow: 'auto'
    },
    content: {
        whiteSpace: 'pre-line'
    },
    section: { mt: 3, mb: 1 },
}


const PolicyContent = (props: { text: string }) => (
  <Typography variant="body2" paragraph>
    {props.text ||
      'This policy has not been provided - please consult the club for details.'}
  </Typography>
);


interface IPoliciesProps {
  color?: string;
  policyPivacy: string;
  policyShipping: string;
  policyReturn: string;
  size: 'small' | 'normal';
  userConfig: {
    businessAlias: string;
    partnerApiKey: string;
  };
  getPolicies: (config: any) => void;
}

export function Policies(props: IPoliciesProps) {
  const {userConfig: {businessAlias, partnerApiKey}} = props;
  const [open, setOpen] = React.useState(false);

  const privacyRef = React.useRef<HTMLDivElement>(null);
  const shippingRef = React.useRef<HTMLDivElement>(null);
  const returnRef = React.useRef<HTMLDivElement>(null);

  const handleOpen = (ref: React.RefObject<HTMLDivElement>) => {
    setOpen(true);

    setTimeout(() => {
        ref!.current!.scrollIntoView({
          behavior: 'smooth'
        });
    }, 100);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (open) {
      props.getPolicies({
          businessAlias,
          partnerApiKey
        });
    }
  }, [open]);

  const label = props.size === 'small'
    ? (
      <Link
        component="button"
        sx={{
          color: props.color || '#000000',
          fontSize: { xs: '0.55rem', sm: '0.6rem', md: '0.75rem', lg: '0.8rem' },
          paddingBottom: { xs: 0, sm: 1 },
        }}
        onClick={() => handleOpen(privacyRef)}
      >
        Shipping and Return Policy
      </Link>
    )
    : (
      <Box display="flex" columnGap={4}>
        <Link component="button" onClick={() => handleOpen(privacyRef)}>
          Privacy Policy
        </Link>
        <Link component="button" onClick={() => handleOpen(shippingRef)}>
          Shipping Policy
        </Link>
        <Link component="button" onClick={() => handleOpen(returnRef)}>
          Return Policy
        </Link>
      </Box>
    );

  return (
    <>
      {label}

      <Modal
        aria-labelledby="policy-modal-title"
        open={open}
        onClose={handleClose}
      >
        <Box sx={classes.modalStyle}>
            <IconButton
                sx={classes.closeButton}
                onClick={handleClose} size="small"
            >
                <CloseIcon />
            </IconButton>
          {/* Privacy Policy Section */}
          <div ref={privacyRef}>
            <Typography sx={classes.section} variant="h6">Privacy Policy</Typography>
            <PolicyContent text={props.policyPivacy} />
          </div>

          <Divider sx={classes.divider} />

          {/* Shipping Policy Section */}
          <div ref={shippingRef}>
            <Typography sx={classes.section} variant="h6">
              Shipping Policy
            </Typography>
            <PolicyContent text={props.policyShipping} />
          </div>

          <Divider sx={classes.divider} />

          {/* Return Policy Section */}
          <div ref={returnRef}>
            <Typography sx={classes.section} variant="h6">
              Return Policy
            </Typography>
            <PolicyContent text={props.policyReturn} />
          </div>

          <DialogActions sx={{ px:0, py: 2 }}>
            <Button
                color="primary"
                    sx={{
                        width: { xs: '100%', sm: 'auto' }
                    }}
                variant="outlined"
                onClick={handleClose}
            >
                Close
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </>
  );
}
